import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Dispatch } from 'redux';
import urlencode from 'urlencode';
import { confirmActiveDirectory, dialogClear } from '../../../stores/auth/actionCreators';
import { invalidToken, isLoggedIn, resetPasswordSuccess } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import CenterContainer from '../../layout/CenterContainer';
import LoadingScreen from '../../navigation/LoadingScreen';
import ConfirmActiveDirectoryError from './ConfirmActiveDirectoryError';
import ConfirmActiveDirectorySuccess from './ConfirmActiveDirectorySuccess';

interface Props extends LocalizeContextProps, RouteComponentProps<{ id: string }> {
    isLoggedIn: boolean;
    success: boolean;
    invalidToken?: boolean;

    dialogClear: () => void;
    confirmActiveDirectoryToken: (id: string, token: string) => void;
}

class ConfirmActiveDirectoryPage extends React.Component<Props> {
    public componentWillMount() {
        this.props.dialogClear();
        const { token } = urlencode.parse(this.props.location.search.substr(1), { charset: 'utf8' });
        this.props.confirmActiveDirectoryToken(this.props.match.params.id, token);
    }

    public render() {
        const t = this.props.translate;

        if (this.props.invalidToken === undefined) {
            return (
                <LoadingScreen text={t('resetPassword.loading.loading') as string} />
            );
        }

        if (this.props.invalidToken) {
            return (
                <CenterContainer>
                    <ConfirmActiveDirectoryError />
                </CenterContainer>
            );
        }

        if (this.props.success) {
            return (
                <CenterContainer>
                    <ConfirmActiveDirectorySuccess />
                </CenterContainer>
            );
        }

        return (
            <LoadingScreen />
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    invalidToken: invalidToken(state),
    isLoggedIn: isLoggedIn(state),
    success: resetPasswordSuccess(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    confirmActiveDirectoryToken: (id: string, token: string) =>
        dispatch(confirmActiveDirectory(id, token)),
    dialogClear: () => dispatch(dialogClear()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(ConfirmActiveDirectoryPage)));
